import { render, staticRenderFns } from "./Zhuguan.vue?vue&type=template&id=fbbaaa4e&scoped=true"
import script from "./Zhuguan.vue?vue&type=script&lang=js"
export * from "./Zhuguan.vue?vue&type=script&lang=js"
import style0 from "./Zhuguan.vue?vue&type=style&index=0&id=fbbaaa4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbaaa4e",
  null
  
)

export default component.exports